import React, {useEffect, useContext, useState} from 'react'
import axios from 'axios'
import { useConfirm } from 'material-ui-confirm';

import {getDateFormat} from '../../utils/Library'
import {getMembers} from '../../utils/Server'

import { ConfigContext } from '../../contexts/ConfigContext'
import { MemberContext } from '../../contexts/MemberContext'

import BoatSpaceLeaseEdit from './boatSpaceLeaseEdit'

import { TableContainer, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material';
import { Paper } from '@mui/material'

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';


import Fab from '@mui/material/Fab';

import Button from '@mui/material/Button';


const BoatSpaceLease = () => {

  const { config, configDispatch } = useContext(ConfigContext);
  const { memberDispatch } = useContext(MemberContext);
  const [leaseList, setLeaseList] = useState([]);
  const [leaseEditOpen, setLeaseEditOpen] = useState(false);
  const [selectedLease, setSelectedLease] = useState(null);
  const [reload, setReload] = useState(false);
  const confirm = useConfirm();

  /////////////////////
  // Server interaction
  /////////////////////
  const getLeaseList = () => {
    axios.get(config.server+'boatspaces/lease/all/'+config.clubId, {
      'headers': {
          'Content-Type': 'application/json', 
          'Authorization': 'Bearer '+config.accessToken},
      })
      .then(res => {
        //console.log(res.data);
        setLeaseList(res.data);
      })
      .catch(err => {
          console.log('Error: ',err)
      })                
  }

  const deleteLease = (id) => {
    axios.delete(config.server+'boatspaces/lease/delete/'+config.clubId+'/'+id, {
      'headers': {
          'Content-Type': 'application/json', 
          'Authorization': 'Bearer '+config.accessToken
        },
      })
      .then(res => {
        setReload(!reload);
      })
      .catch(err => {
          console.log('Error: ',err)
      })            
  }


  ////////////////////
  // useEffect area
  ////////////////////
  useEffect(() => {
    configDispatch({type: 'SET_CURRENT_FUNCTION', functionName: "Leiekontrakter for båtplass"});
    getLeaseList();
    getMembers(config, memberDispatch);
    return () => {
      configDispatch({type: 'SET_CURRENT_FUNCTION', functionName: null});
    }    
  }, [])

  useEffect(() => {
    getLeaseList();
    //console.log("getLeaseList")
  }, [reload])  
  
  ////////////////////
  // Action handlers
  ////////////////////

  const handleAdd = () => {
    //console.log("Add lease");
    setLeaseEditOpen(true);
  }

  const handleEdit = (e) => {
    //console.log("Edit lease no ", e.currentTarget.id);
    setSelectedLease(leaseList.find(l => l.id==e.currentTarget.id));
    setLeaseEditOpen(true);
  }

  const handleDelete = (e) => {
    //console.log("Delete lease no ", e.currentTarget.id);
    const id = e.currentTarget.id
    confirm({ 
      title: "Er du sikker?",
      description: "Hvis du bekrefter så slettes denne leiekontrakten. Det er ikke mulig å angre",
      cancellationText: "Avbryt",
      confirmationText: "Ja"  
    })
      .then(() => { 
        deleteLease(id)
      })
      .catch(() => { 
        console.log("Sletting avbrutt")  
      });
  }

  ///////////
  // UI part
  ///////////


  const leases = leaseList ? (
    leaseList.map(lease => {
      //console.log(lease);
      const btn = lease.attachment ? <Button color="primary" href={config.server.substring(0, config.server.length - 1)+lease.attachment} target="_blank">Vedlegg</Button> : null
      //const delete = lease.completed==1 ? () : null;
      return (
        <TableRow key={lease.id}>
          <TableCell>{lease.boat_space_name}</TableCell>
          <TableCell>{lease.company_name ? lease.company_name : lease.member_name}</TableCell>
          <TableCell>{getDateFormat(lease.valid_from)}</TableCell>
          <TableCell>{lease.deposit}</TableCell>
          <TableCell>{lease.completed=='0'? 'Nei':'Ja'}</TableCell>
          <TableCell>{lease.valid_to ? getDateFormat(lease.valid_to):null}</TableCell>
          <TableCell>{btn}</TableCell>
          <TableCell><EditIcon color="primary" fontSize="small" value={lease.id} id={lease.id} onClick={handleEdit} /></TableCell>
          <TableCell><DeleteIcon color="primary" fontSize="small" value={lease.id} id={lease.id} onClick={handleDelete} /></TableCell>
        </TableRow>
      )
    })
  ) : ("Det er ingen leieavtaler i øyeblikket");


  return (
      <div>
        <Paper>
          <Fab color="primary" aria-label="add" >
              <AddIcon onClick={handleAdd}/>
          </Fab>
          <BoatSpaceLeaseEdit 
              open={leaseEditOpen} 
              setOpen={setLeaseEditOpen} 
              selectedLease={selectedLease} 
              setSelectedLease={setSelectedLease} 
              reload={reload}
              setReload={setReload} />
          <TableContainer>
            <Table component={Paper} size="small" padding="none" >
              <TableHead>
                <TableRow>
                  <TableCell>Båtplass</TableCell>
                  <TableCell>Medlem</TableCell>
                  <TableCell>Gyldig fra</TableCell>
                  <TableCell>Depositum</TableCell>
                  <TableCell>Avsluttet</TableCell>
                  <TableCell>Avsluttet dato</TableCell>
                  <TableCell>Vedlegg</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {leases}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    )
  }

export default BoatSpaceLease;
